import * as signalR from '@microsoft/signalr';
import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '@environments/environment';
import { EfMessageService } from 'src/app/core/common/toast-outlet/ef-message.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private readonly hubConnection: signalR.HubConnection;
  private readonly jobStatusSubject = new Subject<any>();
  private readonly translateService: TranslateService = inject(TranslateService);
  public jobStatus$ = this.jobStatusSubject.asObservable();

  constructor(private readonly efMessageService: EfMessageService) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.signalRHubConnectionUrl, { withCredentials: true }) // For production environment

      // //below code uncomment and use in dev envrionment, while committing changes comments below .withUrl() codes.
      // .withUrl('https://localhost:7204/notify', {
      //   withCredentials: true,
      //   skipNegotiation: true,
      //   transport: signalR.HttpTransportType.WebSockets
      // })

      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.addStatusUpdateListener();
    this.initializeConnection();
  }

  private initializeConnection(): void {
    this.hubConnection.start().catch((error) => {
      console.error('Failed to start SignalR connection:', error);
      this.efMessageService.error({ detail: this.translateService.instant('vbeiSignalRFailed') });
    });
  }

  public addStatusUpdateListener = (): void => {
    this.hubConnection.on('JobStatusNotification', (message: any) => {
      this.jobStatusSubject.next(message);
    });
  };

  public async startConnection(): Promise<void> {
    try {
      await this.hubConnection.start();
    } catch {
      this.efMessageService.error({ detail: this.translateService.instant('vbeiSignalRFailed') });
      setTimeout(() => this.startConnection(), 5000);
    }

    this.hubConnection.onclose(async () => {
      await this.startConnection();
    });

    this.hubConnection.onreconnecting((_error: any) => {
      this.efMessageService.error({ detail: this.translateService.instant('vbeiSignalRConnect') });
    });

    this.hubConnection.onreconnected(() => {});
  }
}
